import { render, staticRenderFns } from "./JBottomNavigation.vue?vue&type=template&id=c0199f66&"
import script from "./JBottomNavigation.vue?vue&type=script&lang=js&"
export * from "./JBottomNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports